(function (root, factory) {
  const api = factory(root);
  if (typeof module === 'object' && module.exports) module.exports = api;
  else root.NFTopbar = api;
})(typeof globalThis !== 'undefined' ? globalThis : this, function (root) {
  function nextIndex(current, length) {
    if (length <= 0) return 0;
    return (current + 1) % length;
  }

  function visibleIndexes(active, length, state) {
    if (length <= 0) return [];
    if (!state.mobile) return Array.from({ length }, (_, index) => index);
    if (state.reducedMotion) return [0];

    const normalized = ((Number(active) || 0) % length + length) % length;
    return [normalized];
  }

  function shouldRotate(state) {
    return state.mobile && !state.reducedMotion && !state.documentHidden && state.length > 1;
  }

  function indicatorStates(active, length, state) {
    if (!state.mobile || length <= 1) return [];
    const visible = new Set(visibleIndexes(active, length, state));
    return Array.from({ length }, (_, index) => visible.has(index));
  }

  if (root.HTMLElement && root.customElements && !root.customElements.get('nf-topbar-carousel')) {
    class NFTopbarCarousel extends root.HTMLElement {
      connectedCallback() {
        this.slides = Array.from(this.querySelectorAll('[data-nf-topbar-slide]'));
        this.indicators = Array.from(this.querySelectorAll('[data-nf-topbar-indicator]'));
        this.activeIndex = 0;
        this.intervalDuration = Number(this.dataset.interval) || 4000;
        this.mobileQuery = root.matchMedia('(max-width: 749px)');
        this.reducedMotionQuery = root.matchMedia('(prefers-reduced-motion: reduce)');
        this.handleEnvironmentChange = this.sync.bind(this);

        this.listenToMedia(this.mobileQuery, true);
        this.listenToMedia(this.reducedMotionQuery, true);
        root.document.addEventListener('visibilitychange', this.handleEnvironmentChange);
        this.classList.add('is-enhanced');
        this.sync();
      }

      disconnectedCallback() {
        this.stopTimer();
        this.listenToMedia(this.mobileQuery, false);
        this.listenToMedia(this.reducedMotionQuery, false);
        root.document.removeEventListener('visibilitychange', this.handleEnvironmentChange);
      }

      listenToMedia(query, attach) {
        if (!query) return;
        const method = attach ? 'addEventListener' : 'removeEventListener';
        const legacyMethod = attach ? 'addListener' : 'removeListener';
        if (typeof query[method] === 'function') query[method]('change', this.handleEnvironmentChange);
        else if (typeof query[legacyMethod] === 'function') query[legacyMethod](this.handleEnvironmentChange);
      }

      getState() {
        return {
          mobile: this.mobileQuery.matches,
          reducedMotion: this.reducedMotionQuery.matches,
          documentHidden: root.document.hidden,
          length: this.slides.length,
        };
      }

      applyVisibility() {
        const state = this.getState();
        const visible = new Set(visibleIndexes(this.activeIndex, this.slides.length, state));

        this.slides.forEach((slide, index) => {
          const isVisible = visible.has(index);
          slide.hidden = !isVisible;
          if (state.mobile) slide.setAttribute('aria-hidden', String(!isVisible));
          else slide.removeAttribute('aria-hidden');
        });

        indicatorStates(this.activeIndex, this.slides.length, state).forEach((isActive, index) => {
          const indicator = this.indicators[index];
          if (!indicator) return;
          indicator.classList.toggle('is-active', isActive);
          indicator.setAttribute('aria-current', isActive ? 'true' : 'false');
        });
      }

      sync() {
        this.stopTimer();
        const state = this.getState();
        if (state.reducedMotion) this.activeIndex = 0;
        this.applyVisibility();

        if (shouldRotate(state)) {
          this.timer = root.setInterval(() => {
            this.activeIndex = nextIndex(this.activeIndex, this.slides.length);
            this.applyVisibility();
          }, this.intervalDuration);
        }
      }

      stopTimer() {
        if (!this.timer) return;
        root.clearInterval(this.timer);
        this.timer = null;
      }
    }

    root.customElements.define('nf-topbar-carousel', NFTopbarCarousel);
  }

  return { nextIndex, visibleIndexes, shouldRotate, indicatorStates };
});
